export default {
    login: {
        title: 'Log in to your account',
        subtitle: 'Enter your credentials to access the admin panel',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        forgotPassword: 'Forgot password?',
        submitButton: 'Log in',
        noAccount: "Don't have an account?",
        contactAdmin: 'Contact administrator',
        credentialsTitle: 'Demo Credentials',
        errorInvalidCredentials: 'Invalid credentials',
        errorLogin: 'Error during login',
    },
    resetPassword: {
        title: 'Reset password',
        subtitle: 'Enter your email and we will send you a link to reset your password',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.com',
        submitButton: 'Send reset link',
        backToLogin: 'Back to login',
        successTitle: 'Email sent!',
        successMessage: 'We sent you a link to reset your password at',
        successInstructions: 'Check your inbox.',
        backToLoginButton: 'Back to Login',
        sendAnotherEmail: 'Send another email',
    },
};

